import { create } from 'zustand';
import { AddCustomerSchemaT } from '../types/schema/customerSchema';

type CustomerRequestStore = {
  currentCustomer: AddCustomerSchemaT | null;
  setCurrentCustomer: (customer: AddCustomerSchemaT | null) => void;
  clearCurrentCustomer: () => void;
};

const useCustomerRequestStore = create<CustomerRequestStore>(set => ({
  currentCustomer: null,
  setCurrentCustomer: customer => set({ currentCustomer: customer }),
  clearCurrentCustomer: () => set({ currentCustomer: null }),
}));

export default useCustomerRequestStore;